import { ReactNode, useCallback } from "react";
import { PermissionProvider, PermissionType } from "@workspace/shared";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useUserDetails } from "@/redux/function";

interface PermissionProviderWrapperProps {
  children: ReactNode;
}

export const PermissionProviderWrapper = ({
  children,
}: PermissionProviderWrapperProps) => {
  const userData = useUserDetails();
  const { permissions } = useSelector((state: RootState) => state.permission);

  const hasPermission = useCallback(
    (permission: PermissionType | PermissionType[]): boolean => {
      // if (userData?.user?.is_admin) {
      //   return true;
      // }

      const requiredPermissions = Array.isArray(permission)
        ? permission
        : [permission];

      const hasPermission = requiredPermissions.some((req) => {
        if (req?.module_name === "Default") {
          return true;
        }

        return permissions?.some((module: any) => {
          if (module.module_name === req.module_name) {
            return module.permissions?.some(
              (perm: { name: string; is_select: boolean }) =>
                perm.name === req.permission && perm.is_select === true,
            );
          }
          return false;
        });
      });

      return hasPermission;
    },
    [userData, permissions],
  );

  return (
    <PermissionProvider hasPermission={hasPermission}>
      {children}
    </PermissionProvider>
  );
};
